import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterCategoriesSearchValueObject extends ValueObject {
  #categories

  constructor({categories}) {
    super()
    this.#categories = categories
  }

  static create({categories}) {
    return new FilterCategoriesSearchValueObject({
      categories: {
        category1Ids: FilterIdsArraySearchValueObject.createForNumbers(categories.category1Ids),
        category2Ids: FilterIdsArraySearchValueObject.createForNumbers(categories.category2Ids)
      }
    })
  }

  static createWithDefaultValue({config, categories}) {
    const {DEFAULT_CATEGORIES_SEARCH} = config.get('searchFilters')

    return new FilterCategoriesSearchValueObject({
      categories: {
        category1Ids: FilterIdsArraySearchValueObject.createForNumbers({
          value: categories?.category1Ids?.length ? categories.category1Ids : DEFAULT_CATEGORIES_SEARCH.category1Ids
        }),
        category2Ids: FilterIdsArraySearchValueObject.createForNumbers({
          value: categories?.category2Ids?.length ? categories.category2Ids : DEFAULT_CATEGORIES_SEARCH.category2Ids
        })
      }
    })
  }

  static createFromUrl({config, categories, url = ''}) {
    const {DEFAULT_CATEGORIES_SEARCH} = config.get('searchFilters')
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')

    if (isRenting) {
      return url.includes(SEMANTIC_KEYWORDS.RENTING.VEHICLE_TYPE_VAN)
        ? new FilterCategoriesSearchValueObject({
            categories: {
              category1Ids: FilterIdsArraySearchValueObject.createForNumbers({
                value: [2900]
              }),
              category2Ids: FilterIdsArraySearchValueObject.createForNumbers({
                value: DEFAULT_CATEGORIES_SEARCH.category2Ids
              })
            }
          })
        : new FilterCategoriesSearchValueObject({
            categories: {
              category1Ids: FilterIdsArraySearchValueObject.createForNumbers({
                value: []
              }),
              category2Ids: FilterIdsArraySearchValueObject.createForNumbers({
                value: []
              })
            }
          })
    }
    return FilterCategoriesSearchValueObject.createWithDefaultValue({config, categories})
  }

  static createFromFilters({categoryId, category2Id}) {
    return new FilterCategoriesSearchValueObject({
      categories: {
        category1Ids: FilterIdsArraySearchValueObject.createForNumbers({value: categoryId ? [categoryId] : []}),
        category2Ids: FilterIdsArraySearchValueObject.createForNumbers({value: category2Id ? [category2Id] : []})
      }
    })
  }

  static createQueryParams({config, categoryId, category2Id}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterCategoriesSearchValueObject({
      categories: {
        category1Ids: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.CATEGORY_1],
          value: categoryId || null
        }),
        category2Ids: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.CATEGORY_2],
          value: category2Id || null
        })
      }
    })
  }

  get isEmpty() {
    return this.#categories.category1Ids.isEmpty && this.#categories.category2Ids.isEmpty
  }

  get categoryId() {
    const [category1Id] = this.#categories.category1Ids.value
    return category1Id
  }

  get category2Id() {
    const [category2Id] = this.#categories.category2Ids.value
    return category2Id
  }

  get queryParams() {
    return {
      ...(!this.#categories.category1Ids.isEmpty && {...this.#categories.category1Ids.queryParam}),
      ...(!this.#categories.category2Ids.isEmpty && {...this.#categories.category2Ids.queryParam})
    }
  }

  get value() {
    return {category1Ids: this.#categories.category1Ids.value, category2Ids: this.#categories.category2Ids.value}
  }

  toJSON() {
    return {
      categories: {
        category1Ids: this.#categories.category1Ids.toJSON(),
        category2Ids: this.#categories.category2Ids.toJSON()
      }
    }
  }
}
